import * as React from 'react'

import { cn } from '@/shared/lib/utils'

type RadioProps = {
	checked?: boolean
	disabled?: boolean
} & React.ComponentProps<'input'>

function Radio({ className, ...props }: RadioProps) {
	return (
		<input
			data-slot='radio'
			{...props}
			type='radio'
			role='radio'
			checked={props.checked}
			className={cn(
				'dark:fill-control size-4 rounded-full border bg-input/20 text-primary focus:border-ring focus:ring-3 focus:ring-ring/30 focus:ring-offset-0 disabled:cursor-not-allowed disabled:text-disabled dark:bg-input/30',
				className
			)}
			aria-disabled={props.disabled}
			aria-checked={props.checked}
		/>
	)
}

export { Radio, type RadioProps }
